import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContractDigitizationBusinessRoutingModule } from './contract-digitization-business-routing.module';
import { ContractDigitizationBusinessComponent } from './contract-digitization-business.component';
import { ListContractDigitizationBusinessComponent } from './list-contract/list-contract-business.component';
import { AddContractDigitizationBusinessComponent } from './add-contract/add-contract.component';
import {SharedModule} from '../../../../../../shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
    NzAutocompleteModule,
    NzDatePickerModule,
    NzIconModule,
    NzInputModule,
    NzPopconfirmModule, NzSpinModule,
    NzTableModule, NzTagModule, NzToolTipModule
} from 'ng-zorro-antd';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {NgMatAutocompleteModule} from '../../../../../../shared/components/autocomplete/autocomplete.module';
import {FilterContractDigitizationBusinessComponent} from './filter-contract-digitization/filter-contract-digitization-business.component';
import {ViewContractBusinessComponent} from './view-contract/view-contract-business.component';
import { UploadMultiFileAttachmentsComponent } from './upload-multi-file-attachments/upload-multi-file-attachments.component';


@NgModule({
  declarations: [ContractDigitizationBusinessComponent,
    ListContractDigitizationBusinessComponent,
    FilterContractDigitizationBusinessComponent,
    ViewContractBusinessComponent,
    AddContractDigitizationBusinessComponent,
    FilterContractDigitizationBusinessComponent,
    UploadMultiFileAttachmentsComponent
  ],
    imports: [
        CommonModule,
        SharedModule,
        ContractDigitizationBusinessRoutingModule,
        TranslateModule,
        ReactiveFormsModule,
        NzDatePickerModule,
        NgxExtendedPdfViewerModule,
        NgMatAutocompleteModule,
        FormsModule,
        NzAutocompleteModule,
        NzInputModule,
        NzTableModule,
        NzIconModule,
        NzPopconfirmModule,
        NzSpinModule,
        NzTagModule,
        NzToolTipModule
    ],
    entryComponents: [ViewContractBusinessComponent, UploadMultiFileAttachmentsComponent]
})
export class ContractDigitizationBusinessModule {}
